export class DefaultFilter {
    custIds?: number[] = [];
    date1?: string;
    date2?: string;
    alarmTypes?: number[] = [];
    infractionTypes?: number[] = [];
    driverIds?: number[] = [];
    vehicleIds?: number[] = [];
    id?: number;
}
